import { createContext, useContext } from 'react';

/**
 * The element at the right end of the breadcrumb row, when the page asked for one
 * (`DashboardPageChrome.breadcrumbTrailing`); `null` until it is mounted.
 */
export const BreadcrumbTrailingSlotContext = createContext<HTMLElement | null | undefined>(
  undefined
);

/**
 * The breadcrumb row's trailing element: `undefined` outside the dashboard shell (render inline),
 * `null` inside it while there is no slot yet (render nothing), else the element to portal into.
 */
export function useBreadcrumbTrailingSlot(): HTMLElement | null | undefined {
  return useContext(BreadcrumbTrailingSlotContext);
}
